export var CLIENT_BACK_OFFICE_URL = "CLIENT_BACK_OFFICE_URL";
